import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { ActionsColumn as ActionsColumnCommon } from '@otp/ui';
import { Assign, Configure, Status } from '@otp/icons';
import { ActionModals, IssueTicketAction } from './action-modals';
import { IssueTicket } from '../../config';
import { Can } from 'src/utils/can';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';

type ActionsColumnProps = {
  issueTicket: IssueTicket;
};

export const ActionsColumn = ({ issueTicket }: ActionsColumnProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'issue.ticket.list.columns.action-options',
  });

  const [showModal, setShowModal] = useState<IssueTicketAction>();

  const actions = [
    {
      id: 'edit',
      label: t('edit'),
      icon: <Configure />,
      onClick: () => setShowModal(IssueTicketAction.Edit),
    },
    {
      id: 'assign',
      label: t('assign'),
      icon: <Assign />,
      onClick: () => setShowModal(IssueTicketAction.Assign),
    },
    {
      id: 'status',
      label: t('change-status'),
      icon: <Status />,
      onClick: () => setShowModal(IssueTicketAction.Status),
    },
  ];

  return (
    <Can I={Actions.Write} a={Subjects.Issues} appArea={AppArea.Common}>
      <div onClick={(e) => e.stopPropagation()}>
        <ActionsColumnCommon actions={actions} />
        {showModal && (
          <ActionModals
            issueTicket={issueTicket}
            action={showModal}
            onClose={() => setShowModal(undefined)}
          />
        )}
      </div>
    </Can>
  );
};
